import { render, staticRenderFns } from "./BtnEmitirRelatorio.vue?vue&type=template&id=1482e0ed"
import script from "./BtnEmitirRelatorio.vue?vue&type=script&lang=js"
export * from "./BtnEmitirRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports